// import { asArray } from "./as-array";

import { asArray } from "./as-array";

const iterateById: <T extends { _id: string }>(item: T) => string = i => i._id;

// TODO! FIX, NOT WORKING SINCE TYPESCRIPT 3.9
// /**
//  * Create a union of unique items of T
//  *
//  * @template T
//  * @param {((T | T[])[])} items Items to union
//  * @param {{
//  *         iteratee?: (item: T) => any; customize getting value to check.
//  *         isEqual?: (a: T, b: T) => boolean; customize equal check.
//  *     }} [options]
//  * @returns {T[]}
//  */
// const union = <T>(
//     items: (T | T[])[],
//     options?: {
//         // eslint-disable-next-line @typescript-eslint/no-explicit-any
//         iteratee?: (item: T) => any;
//         isEqual?: (a: T, b: T) => boolean;
//     }
// ): T[] => {
//     const _items = items.flat();

//     const hasIteratee = !!options?.iteratee;
//     const hasCustomIsEqual = !!options?.isEqual;

//     if (!hasCustomIsEqual && !hasIteratee) {
//         return Array.from(new Set(_items));
//     }

//     const iteratee = options?.iteratee || ((item: T) => item);
//     const isEqual = options?.isEqual || ((a: T, b: T) => a === b);

//     const values = hasIteratee ? _items.map(iteratee) : _items;
//     // eslint-disable-next-line @typescript-eslint/no-explicit-any
//     const foundDuplicates: Set<any> = new Set();
//     const output = _items.reduce((agg, item, index) => {
//         // Get current item value
//         const value = values[index];

//         // Check for duplicates
//         let duplicate = false;
//         for (let i = 0; i < values.length; i++) {
//             if (i !== index && isEqual(values[i], value)) {
//                 duplicate = true;
//                 break;
//             }
//         }

//         // If not a duplicate, or if an unadded duplicate?
//         if (!duplicate || !foundDuplicates.has(value)) {
//             foundDuplicates.add(value);
//             agg.push(item);
//         }

//         return agg;
//     }, [] as T[]);

//     return output;
// };

const toUniqueArray = <T>(...inputs: (T | T[] | undefined | null)[]): T[] => {
    return Array.from(
        new Set(
            inputs
                .flatMap(inp => (!inp ? null : asArray<T>(inp)))
                .filter(Boolean) as T[]
        )
    );
};

export { toUniqueArray, iterateById };
// export { union };
